module.exports = __webpack_public_path__ + "img/mrxweb.e54bb8c7.svg";